import camelCase from "lodash/camelCase";

export const higherCaseToCamelCase = (str) => {
    return camelCase(str);
};
